import React, { Component } from 'react'
import sha256 from 'js-sha256'
import { connect } from 'redaction'
import { ga, mixpanel, pintrk, snaptr, sentry, constants, dataLayer, compose } from 'common/helpers'

import injectGlobals from 'decorators/injectGlobals'

import s from './Analytics.scss'


class Analytics extends Component {

  async componentDidMount() {
    const { me, me: { id, email, gender }, data, specialFlowName } = this.props
    const {
      paymentType, paymentMethod,
      ecommerceOrderId, ecommerceOrderNumber,
      subscriptionOrderNumber, subscriptionPriceWithDiscount, subscriptionPlan, isResubscribe,
      actualPrice, totalAmount, cart, productCount, couponCode, offer, couponType,
    } = data

    console.log('Analytics data:', data)

    /* DataLayer -------------------------------- */

    // TODO remove subscriptionPrice and actual price, when we complete new paymentPage
    const totalAmountDollars = parseFloat(actualPrice) || totalAmount / 100

    if (
      paymentType === constants.paymentTypes.coupon
      || paymentType === constants.paymentTypes.subscription
      || paymentType === constants.paymentTypes.subscriptionAndEcommerce
      || paymentType === constants.paymentTypes.giftSubscription
    ) {
      dataLayer.push({
        event: 'subscription thank you page',
        subscription: {
          id: subscriptionOrderNumber,
          chargeAmount: totalAmountDollars || parseFloat(subscriptionPriceWithDiscount),
          coupon: couponCode,
          plan: subscriptionPlan,
          couponType,
          offer,
        },
        user: me,
        specialFlowName,
      })

      if (ecommerceOrderNumber) {
        dataLayer.push({
          ecommerce: {
            purchase: {
              actionField: {
                id: `s-${ecommerceOrderNumber}`,
                revenue: totalAmountDollars,
              },
            },
          },
        })
      }
    }

    if (paymentType === constants.paymentTypes.order) {
      dataLayer.push({
        event: 'order thank you page',
        subscription: {
          id: ecommerceOrderNumber,
          chargeAmount: totalAmountDollars,
        },
        user: me,
      })
    }

    /* Bing ------------------------------------ */

    if (
      paymentType === constants.paymentTypes.subscription
      || paymentType === constants.paymentTypes.subscriptionAndEcommerce
      || paymentType === constants.paymentTypes.giftSubscription
    ) {
      if (!window.uetq) {
        window.uetq = []
      }

      const value = Number(totalAmountDollars || parseFloat(subscriptionPriceWithDiscount))

      if (Number.isNaN(value)) {
        sentry.captureException('ev should be a number', {
          extra: {
            totalAmountDollars,
            subscriptionPriceWithDiscount,
            ...data,
          },
        })
      }
      else {
        window.uetq.push({
          ec: 'subscription',
          ea: 'purchased',
          el: '1m',
          ev: `${value}`,
        })
      }
    }

    /* Mixpanel -------------------------------- */

    if (
      paymentType === constants.paymentTypes.coupon
      || paymentType === constants.paymentTypes.subscription
      || paymentType === constants.paymentTypes.giftSubscription
      || paymentType === constants.paymentTypes.subscriptionAndEcommerce
    ) {
      const subscriptionType = paymentType === constants.paymentTypes.subscription ? 'order' : 'gift'

      mixpanel.track('Thank you', {
        type: subscriptionPlan,
        subscriptionType,
        subscriptionId: subscriptionOrderNumber,
        coupon: couponCode,
        couponPresence: Boolean(couponCode),
        subscriptionOffer: offer,
        billingType: paymentMethod,
        specialFlowName,
      })
    }

    if (
      paymentType === constants.paymentTypes.ecommerce
      || paymentType === constants.paymentTypes.subscriptionAndEcommerce
    ) {
      try {
        const productCategories = [ ...new Set(cart.products.ids.map((id) => cart.products.items[id].category)) ]

        mixpanel.track('Thank you ecommerce', {
          ecommerceType: productCategories,
          billingType: paymentMethod,
        })
      }
      catch (err) {}
    }

    /* Snapchat --------------------------------- */

    if (paymentType === constants.paymentTypes.subscription && !isResubscribe) {
      const purchaseEventPayload = {
        value: totalAmountDollars,
        currency: 'USD',
        content_type: 'subscription',
        gender: gender === 'female' ? 'woman' : 'men',
      }

      snaptr.track('PURCHASE', purchaseEventPayload)
    }

    /* Ga -------------------------------------- */

    ga.send('event', 'category', 'thank you page')

    /* RockerBox ---------------------------------- */

    const purchaseEventData = {
      event: 'purchase',
      user: {
        id,
        gender,
        emailhash: email ? sha256(email) : email,
      },
      paymentType,
      cart: JSON.stringify(cart),
      count: productCount,
      revenue: totalAmountDollars,
    }

    if (ecommerceOrderNumber) {
      dataLayer.push({ ...purchaseEventData, ecommerceOrderNumber })
    }

    if (subscriptionOrderNumber) {
      dataLayer.push({ ...purchaseEventData, subscriptionOrderNumber })
    }

    /* Pintrk ---------------------------------- */

    if (
      ecommerceOrderNumber && ecommerceOrderId && (
        paymentType === constants.paymentTypes.ecommerce
        || paymentType === constants.paymentTypes.subscriptionAndEcommerce
      )
    ) {
      pintrk.track('checkoutecommerce')
    }

    if (subscriptionOrderNumber) {
      pintrk.track('checkout')
    }
  }

  render() {
    const { data: { totalAmount, subscriptionOrderNumber, actualPrice, subscriptionPrice } } = this.props

    const totalVal = actualPrice || totalAmount / 100 || subscriptionPrice

    return (
      <div className={s.analytics}>
        <img
          src={`https://shareasale.com/sale.cfm?amount=${totalVal}&tracking=${subscriptionOrderNumber}&transtype=sale&merchantID=55102&xtype=subscription`}
          width="1"
          height="1"
          alt=""
        />
      </div>
    )
  }
}


export default compose(
  connect({
    me: 'models.me',
  }),
  injectGlobals(({ getCookieValue }) => ({
    specialFlowName: getCookieValue(constants.cookieNames.specialFlowName),
  })),
)(Analytics)
